import { useAppDispatch, useAppSelector } from "app/hooks";
import { getAuthActionState } from "app/reducers/authSlice";
import { getMe } from "app/thunks/authAPI";
import { NAVIGATOR } from "features/navigation/index";
import { AuthLayout } from "features/navigation/layouts/AuthLayout";
import { Layout } from "features/navigation/layouts/Layout";
import { AuthNavigator } from "features/navigation/navigators/AuthNavigator";
import { MainNavigator } from "features/navigation/navigators/MainNavigator";
import { tokenListener } from "libraries/firebase/firebase";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { Spinner } from "ui";

export const Routes = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isAuthenticating, user } = useAppSelector(getAuthActionState);
  const token = localStorage.getItem("token");

  const authRoutes = [
    NAVIGATOR.signIn,
    NAVIGATOR.updatePassword,
    NAVIGATOR.resetPassword,
    NAVIGATOR.resetPasswordInstructionsSent,
    NAVIGATOR.resetPasswordError,
  ];

  const isAuthRoute = authRoutes.includes(location.pathname);

  useEffect(() => {
    if (token) tokenListener();
  }, [token]);

  useEffect(() => {
    if (token) dispatch(getMe());
  }, [dispatch, token]);

  if (isAuthenticating && token) {
    return (
      <div className="flex w-full justify-center items-center bg-faux-dark-gunmetal h-screen">
        <Spinner size={60} />
      </div>
    );
  }

  if (token && isAuthRoute) {
    return <Redirect to={NAVIGATOR.home} />;
  }

  return (
    <>
      {!token ? (
        <AuthLayout>
          <AuthNavigator />
        </AuthLayout>
      ) : (
        <Layout role={user?.role}>
          <MainNavigator />
        </Layout>
      )}
    </>
  );
};
